<template>
  <div class="manualRecordData">
    <div class="col-12 row text-center mx-0 table-responsive px-0" style="">
      <b-table
        :items="manualRecordDataItem"
        :fields="manualRecordDataFields"
        sticky-header="447px"
        :no-border-collapse="true"
        class="manualRecordData-table-detail manualRecordData-table-detail-select"
      >
        <template #cell(total_weight)="data" style="">
          {{ data.value.toLocaleString("en-US") }}
        </template>
        <template #cell(modified_at)="data">
          <template v-if="data.value == ''">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
        <template #cell(changeUser)="data">
          <template v-if="data.value == ''">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
        <template #cell(reason)="data">
          <template v-if="data.value == ''">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
        <template #cell(detail)="data">
          <b-button
            size="sm"
            style="height: 21px;
                     line-height: normal;
                     line-height: 13px;
                     background-color: #4b8c80;
                     border-color: #4b8c80;"
            @click="query_detailData(...data.value)"
          >
            明細
          </b-button>
        </template>
      </b-table>
    </div>
    <modal
      :modalShow="modalShow"
      size="xl"
      headerClass="mes-modal-title"
      footerClass="d-none"
    >
      <template v-slot:modalheader>
        <button type="button" class="close" @click="toggle_modal()">×</button>
      </template>
      <template v-slot:default>
        <b-row>
          <b-col cols="12" class="px-5">
            <commonWorkorderTable :workorderItem="workorderItem" />
            <sourceRecord
              :workID="work_code"
              :processID="project_id"
              :sourceData="sourceData"
            />
          </b-col>
        </b-row>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import modal from "@/components/modal.vue";
import commonWorkorderTable from "@/components/orderManagement/table/commonWorkorderTable.vue";
import sourceRecord from "@/components/orderManagement/sourceRecord.vue";
export default {
  name: "manualRecordData",
  data() {
    return {
      modalShow: false,

      work_code: "",
      project_id: "",
      workorderItem: [],
      sourceData: []
    };
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      manualRecordDataFields: "manualRecordData/get_manualRecordDataFields",
      manualRecordDataItem: "manualRecordData/get_manualRecordDataItem"
    })
  },
  components: {
    modal,
    commonWorkorderTable,
    sourceRecord
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      trigger_loadScreenModal: "loadscreenmodal/trigger_loadScreenModal"
    }),
    toggle_modal() {
      let vm = this;
      vm.modalShow = !vm.modalShow;
    },
    query_detailData(
      work_code,
      project_id,
      device_name,
      work_end_time,
      trans_times
    ) {
      let vm = this;
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["work_code"] = work_code;
      params["project_id"] = project_id;
      params["device_name"] = device_name;
      params["work_end_time"] = work_end_time;
      params["trans_times"] = trans_times;
      params["whichFunction"] = "manualRecordDetail";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          let processID = result.QueryTableData.processSelected;
          let workorderItem = result.QueryTableData.workorderItem;
          let sourceData = result.QueryTableData.sourceData;
          vm.workorderItem = workorderItem;
          if (processID == 5) {
            sourceData.forEach(data => {
              data.wireItem.push({
                index: "",
                in_scroll_no: "",
                scroll_no: "",
                orgScroll_no: "",
                code: "",
                chinese_name: "",
                furnaceCode: "",
                in_consumption: "",
                consumption: "",
                orgConsumption: "",
                org_code: "",
                reason: [],
                del: ""
              });
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: ""
              });
            });
          } else if (processID == 6) {
            sourceData.forEach(data => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: ""
              });
            });
          } else if (processID == 7) {
            sourceData.forEach(data => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: ""
              });
            });
          }
          vm.work_code = work_code;
          vm.project_id = project_id;
          vm.sourceData = sourceData;
          if (sourceData.length == 0) {
            vm.set_alertMsg(`查無資料`);
            vm.settimeout_alertModal();
          }

          vm.toggle_modal();
        } else {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        }
      });
    }
  }
};
</script>

<style></style>
<style lang="scss">
.manualRecordData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.manualRecordData-table-detail th,
.manualRecordData-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.manualRecordData-table-detail td {
  font-size: 1rem;
}
.manualRecordData-table-detail th:first-child,
.manualRecordData-table-detail td:first-child {
  border-left: 1px solid;
}
.manualRecordData-table-detail-select tr th:nth-child(1),
.manualRecordData-table-detail-select tr td:nth-child(1) {
  width: 120px;
  min-width: 120px;
}
.manualRecordData-table-detail-select tr th:nth-child(2),
.manualRecordData-table-detail-select tr td:nth-child(2) {
  width: 120px;
  min-width: 120px;
}
.manualRecordData-table-detail-select tr th:nth-child(3),
.manualRecordData-table-detail-select tr td:nth-child(3) {
  width: 130px;
  min-width: 130px;
}
.manualRecordData-table-detail-select tr th:nth-child(4),
.manualRecordData-table-detail-select tr td:nth-child(4) {
  width: 175px;
  min-width: 175px;
}
.manualRecordData-table-detail-select tr th:nth-child(5),
.manualRecordData-table-detail-select tr td:nth-child(5) {
  width: 120px;
  min-width: 120px;
}
.manualRecordData-table-detail-select tr th:nth-child(6),
.manualRecordData-table-detail-select tr td:nth-child(6) {
  width: 200px;
  min-width: 200px;
}
.manualRecordData-table-detail-select tr th:nth-child(7),
.manualRecordData-table-detail-select tr td:nth-child(7) {
  width: 90px;
  min-width: 90px;
}
.manualRecordData-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.manualRecordData-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.manualRecordData-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/manualRecordData.vue